<script>
import _ from "lodash"
export default {
  name: "DialogSetComments",
  props: {
    comment_dialog_visible: {
      type: Boolean
    },
    current_item: {
      type: Object
    }
  },
  data: ()=>({
    inner_comments: ''
  }),
  methods: {
    CommentDialogClose(){
      this.$emit('CommentDialogClose')
    },
    setComment(){
      this.$emit('setComment', {
        comments: this.inner_comments
      })
    }
  }
}
</script>

<template>
  <v-dialog
      content-class="rounded-xl"
      @click:outside="CommentDialogClose"
      v-model="comment_dialog_visible"
      width="400"
  >
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
                icon
                @click="CommentDialogClose"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-h5">
            Комментарий
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-textarea
            class="rounded-xl text-justify"
            :value="current_item.comments"
            @input="inner_comments = $event"
            outlined
            auto-grow
            name="input-7-4"
            label="Дополнительно"
        >
        </v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn
            class="mx-auto rounded-xl"
            @click="setComment"
            color="teal"
            outlined
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>